import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { color, query } from '@design/templateFns';

export interface MiscComponentsProps {
  color: string;
  hoverColor?: string;
  link?: string;
  size: string;
}

export const NavArrow = ({ color = '#1B76B0', size = '36' }: MiscComponentsProps): ReactNode => {
  return (
    <>
      <StyledPATH
        color={color}
        width={size}
        viewBox="0 0 20 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.68887 7.24414L18.7659 7.24414"
          stroke="#282828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4743 1.7806L18.7659 7.24418L12.4743 12.7078"
          stroke="#282828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </StyledPATH>
    </>
  );
};

export const Search = ({
  color = '#1B76B0',
  hoverColor = 'black',
  link = 'https://www.google.com',
  size = '36',
}: MiscComponentsProps): ReactNode => {
  return (
    <>
      {link ? (
        <a href={link} rel="noopener noreferrer">
          <span>
            <StyledPATH
              hoverColor={hoverColor}
              color={color}
              width={size}
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 14 14"
            >
              <path
                d="M6.417 11.083a4.667 4.667 0 100-9.333 4.667 4.667 0 000 9.333zM12.25 12.25L9.713 9.712"
                stroke="#1B76B0"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </StyledPATH>
          </span>
        </a>
      ) : (
        <span>
          <svg width={size} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
              d="M6.417 11.083a4.667 4.667 0 100-9.333 4.667 4.667 0 000 9.333zM12.25 12.25L9.713 9.712"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </>
  );
};

const StyledSVG = styled.svg<{ color: string; hoverColor: string }>`
  ${(props: { color: string; hoverColor: string }) => css`
    fill: ${props.color};
    transition: ease-in 0.2s;
    &:hover {
      fill: ${props.hoverColor};
    }
  `}
`;

const StyledPATH = styled.svg<{ color: string; hoverColor?: string }>`
  ${(props) => css`
    path {
      stroke: ${props.color};
      transition: ease-in 0.2s;
    }

    &:hover {
      path {
        stroke: ${props.hoverColor};
      }
    }
  `}
`;

export const Plus = () => {
  return (
    <svg
      data-testid="accordion-plus"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="10.125" y1="4.03906" x2="10.125" y2="17.3724" stroke="#242323" strokeWidth="1.5" />
      <line x1="3.3335" y1="10.5806" x2="8.3335" y2="10.5806" stroke="#242323" strokeWidth="1.5" />
      <line x1="11.667" y1="10.5806" x2="16.667" y2="10.5806" stroke="#242323" strokeWidth="1.5" />
    </svg>
  );
};

export const Minus = () => {
  return (
    <svg
      data-testid="accordion-minus"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="16.6665" y1="10.125" x2="3.33317" y2="10.125" stroke="#242323" strokeWidth="1.5" />
    </svg>
  );
};
